import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaTrash } from "react-icons/fa";
import { Container, Row, Col, Button, Form, Table } from "react-bootstrap";
import Swal from "sweetalert2"; // Import SweetAlert2

const Galleries = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    title: "",
    image_path: null,
  });

  // Fetch gallery images from API
  const fetchGallery = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-gallery`
      );
      setGallery(res.data.gallery);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch gallery images", "error"); // Use SweetAlert for error
      console.error("Error fetching gallery:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setForm({ ...form, [name]: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.title || !form.image_path) {
      Swal.fire("Error", "All fields are required!", "error"); // SweetAlert for validation error
      return;
    }

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("image_path", form.image_path);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/add-gallery`,
        formData
      );
      setForm({ title: "", image_path: null });
      Swal.fire("Success", "Image added to the gallery!", "success"); // SweetAlert for success
      fetchGallery(); // refresh list
    } catch (err) {
      Swal.fire("Error", "Failed to upload image", "error"); // SweetAlert for upload error
      console.error("Error uploading gallery image:", err);
    }
  };

  const deleteImage = async (id) => {
    // Use SweetAlert2 for the confirmation dialog
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/delete-gallery/${id}`
        );
        setGallery(gallery.filter((img) => img.id !== id));
        Swal.fire("Deleted!", "Your image has been deleted.", "success"); // SweetAlert for success
      } catch (error) {
        Swal.fire("Error", "Failed to delete the image", "error"); // SweetAlert for error
        console.error("Error deleting image:", error);
      }
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <Container className="my-5">
      <Row>
        {/* Left Column: Form to Add Images */}
        <Col md={4}>
          <h2 className="text-primary mb-4">Add New Gallery Image</h2>
          <Form
            onSubmit={handleSubmit}
            className=" p-4 rounded shadow-sm"
            style={{ backgroundColor: "aliceblue" }}
          >
            <Form.Group controlId="formTitle">
              <Form.Label className="fw-bold mb-2">Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={form.title}
                onChange={handleChange}
                placeholder="Enter title"
                required
              />
            </Form.Group>

            <Form.Group controlId="formLargeImage">
              <Form.Label className="fw-bold mb-2 mt-3">
                Gallery Image
              </Form.Label>
              <Form.Control
                type="file"
                name="image_path"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button
              type="submit"
              variant="success"
              className="w-100 mt-5 fw-bold"
            >
              Add Image
            </Button>
          </Form>
        </Col>

        {/* Right Column: Gallery Images Table */}
        <Col md={8}>
          <h2 className="text-primary mb-4">Gallery Images</h2>
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : (
            <Table
              style={{ backgroundColor: "aliceblue" }}
              bordered
              hover
              responsive
              className="text-center"
            >
              <thead className="table-primary">
                <tr>
                  <th>Title</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {gallery.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${item.image_path}`}
                        alt={item.title}
                        style={{ width: "100px", height: "120px" }}
                      />
                    </td>

                    <td>
                      <Button
                        variant="danger"
                        onClick={() => deleteImage(item.id)}
                        className="text-white"
                      >
                        <FaTrash /> Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Galleries;
